<template>
    <div class="container relative">
        <SettingsPageMenu :current="currentRouteName"></SettingsPageMenu>

        <router-view :key="currentRouteName"></router-view>
    </div>
</template>

<script>

    import SettingsPageMenu from "./SettingsPageMenu";

    export default {
        name: "SettingsPage",

        components: {
            SettingsPageMenu,
        },

        computed: {
            currentRouteName() {
                return this.$route.name;
            },

        },

    }
</script>

<style scoped>
    h2 {
        margin-top: 0;
    }

    hr {
        margin: 30px 0 20px;
    }
</style>